module.exports = __webpack_public_path__ + "img/f318aeb.jpg";